import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { formatearFechaMoment_a_String, formatearFechaMoment_a_StringFormatoReporte } from '../../funciones_globales/format';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { cargarCatalogos_OtrosConIndicador } from '../../funciones_globales/catalogos';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormCon09 extends React.Component{
    constructor(props) {
		super(props);
		
		this.state = {
			fechaDesde: null,
			fechaHasta: null,
			tiposAsiento: [],
			tipoAsiento_sel: null
		};
			
		this.handleInputChange = this.handleInputChange.bind(this);		
		this.limpiarDatos = this.limpiarDatos.bind(this);
		this.generarReporteAsientosPorComprob = this.generarReporteAsientosPorComprob.bind(this);		
	}

	componentDidMount(){
		Promise.all([
			cargarCatalogos_OtrosConIndicador('TIPOASIENTO-IND'),
			this.props.generar_LogAuditoriaIngresoForm('0809'),
		])
		.then(([tiposAsiento]) => {
			try {
				let fechaProceso = getFechaProcesoPorModulo('08');				
	
				this.setState({
					fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'),
					fechaDesde: moment(fechaProceso, 'DD/MM/YYYY'),
					tiposAsiento
				});
				
			} catch (error) {
				alert(`Error al inicializar la pantalla. Error: ${error}`);
			}			
		})
		.catch(error => {
			alert(error);
		});		
	}

	componentWillUnmount(){
		this.props.generar_LogAuditoriaSalidaForm('0809');
	}	

	handleInputChange(event){    
		const target = event.target;       
		const name = target.name;    
		const value = target.type === 'checkbox' ? target.checked : target.value;
		this.setState({
			[name]: value
		});
	}	

	limpiarDatos(){
		try {
			let fechaProceso = getFechaProcesoPorModulo('08');				

			this.setState({
				fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'),
				fechaDesde: moment(fechaProceso, 'DD/MM/YYYY'),
				tipoAsiento_sel: null
			});
			
		} catch (error) {
			alert(`Error al inicializar la pantalla. Error: ${error}`);
		}
	}

	generarReporteAsientosPorComprob(){
		try {
			let fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
            if (!validarFechaMomentEnFormatoString(fechaDesde)){
                alert('La fecha Desde es inválida.');
                return;
            }
            
            let fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);
            if (!validarFechaMomentEnFormatoString(fechaHasta)){
                alert('La fecha Hasta es inválida.');
                return;
			}
			
			if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){        
                alert(`La fecha Desde debe ser menor a: ${formatearFechaMoment_a_String(this.state.fechaHasta)}`);
                return;
            }

			let urlReportWithParams=`&rpt=81`;
			urlReportWithParams+=`&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}`;
            urlReportWithParams+=`&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`;

            if(this.state.tipoAsiento_sel){
                urlReportWithParams+=`&param3=${this.state.tipoAsiento_sel.value}`;
            }

			visualizarReporteEnPdf(urlReportWithParams);

		} catch (error){
			alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
		}
	}

	render(){
		return(
			<ContenedorForm porc_ancho={50}>
				<HeaderForm>
					<TituloForm>Asientos/Comprobantes</TituloForm>
				</HeaderForm>
				<CuerpoForm>
					<Row margen_arriba={20}>
						<ContainerCol className='col-sm-2'>
							<LabelForm>Fecha Desde:</LabelForm>
						</ContainerCol>
						<ContainerCol className='col-sm-3'>
							<PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaDesde)=>{this.setState({fechaDesde})}}/>
						</ContainerCol>
					
						<ContainerCol className='col-sm-2'>
							<LabelForm>Fecha Hasta:</LabelForm>
						</ContainerCol>
						<ContainerCol className='col-sm-3'>
							<PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaHasta)=>{this.setState({fechaHasta})}}/>
						</ContainerCol>
					</Row>

					<Row margen_arriba={20}>
						<ContainerCol className='col-sm-2'>
							<LabelForm>Tipo:</LabelForm>
						</ContainerCol>
						<ContainerCol className='col-sm-5'>
							<ReactSelect
								options={ this.state.tiposAsiento }
								value={this.state.tipoAsiento_sel}
								func_onChange={(value) => {if(Array.isArray(value)){value=null;} this.setState({tipoAsiento_sel: value});}}
							/>
						</ContainerCol>
					</Row>
					<Row margen_arriba={20}>
						<ContainerCol className='col-sm-12'>
							<div className='btn-group btn-group-sm pull-right' role='group' aria-label='...'>
								<button type='button' className='btn btn-info' onClick={this.generarReporteAsientosPorComprob}>
									<i className='fa fa-print fa-fw'></i>Imprimir
								</button>
								<button type='button' className='btn btn-default' onClick={this.limpiarDatos}>
									<i className='fa fa-trash fa-fw'></i>Limpiar
								</button>
							</div>
						</ContainerCol>
					</Row>					
				</CuerpoForm>
			</ContenedorForm>		
		);
	}
}

const mapStateToProps = ((state) => {
	return {
		isVisibleLoading: state.ui.isVisibleLoading, 		
		permiso: state.sesion.valoresSesionForm.Permiso		
	};
});
  
const mapDispatchToProps = ((dispatch) => {  
	return bindActionCreators({
		cambiar_VisualizacionLoading,
		generar_LogAuditoriaIngresoForm,
		generar_LogAuditoriaSalidaForm		
	}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormCon09);